import { Injectable } from '@angular/core';
import { Store } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class SelectedAgreementsStoreService extends Store<string[]> {

  constructor() {
    super(null, 'SelectedAgreements');
  }
}
